import { render, staticRenderFns } from "./MtipotransporteModals.vue?vue&type=template&id=d471cba0"
import script from "./MtipotransporteModals.vue?vue&type=script&lang=js"
export * from "./MtipotransporteModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports